import React, {useState, useEffect} from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core/';
import {AssignmentInd, Today, Person } from '@material-ui/icons';
import { useStyles } from "./style";
import DialogLoadingMessage from 'components/BackDrop';
import { showMessagePersonalizedPosition } from 'services/SweetAlert'
import {functions} from 'constants/index';

//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import allActions from 'store/actions';
import { useSelector, useDispatch } from 'react-redux'
// Api Services
import ApiServices from 'services/ApiServices';

function EstatusUsuario(props) {   
    const classes = useStyles();
    const dispatch = useDispatch(),
    [userState, setUserState] = useState({state:'', ballotNumber:''}),
    [estaFallecido, setEstaFallecido] = useState({state: '', fechaDefuncion:''}),
    [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});

    // validamos si EL CUI DEL CIUDADANO DE LA SOLICITUD ESTE EMPADRONADO O NO
    const getUserState = async ()=>{
        setLoadingMessage({loading: true, title:'Validando estado en el padrón ...'})
        if(!props.estadoPadronDelCiudadanoEstaEmpadronado){
            try {
                // PROPS_DPI_SOLICITUD_PORTAL_WEB debe de tener el nuevo CUI al seleccionarse un homónimo o tener el mismo en caso exista una actual

                let response = await ApiServices.solicitudesDeEmpadronamiento.validarEmpadronado(props.cuiDPISolicitudPortalWeb)
                if(response.error!==null){
                    let datos = {}
                    datos.status = false
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO(false)
                    setUserState({state: 'No', ballotNumber:''})
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
                    dispatch(allActions.setResidenciaElectoralActualEnElPadron(datos));
                }else{
                    let datos = response.data
                    console.log("***************** COMPONENTE ESTADO EN EL PADRON *****************");
                    console.log("NO DE BOLETA", response.data.numeroBoleta);
                    datos.status = true
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO(response.data.numeroBoleta)
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO(true)
                    setUserState({state: 'Si', ballotNumber:response.data.numeroBoleta})
                    dispatch(allActions.setResidenciaElectoralActualEnElPadron(datos));
                }  
            } catch (error) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }else{
            setUserState({state: props.estadoPadronDelCiudadanoEstaEmpadronado ? 'Si' : 'No' , ballotNumber: props.estadoPadronDelCiudadanoEstaEmpadronado})
        }
        setLoadingMessage({loading: false, title:''})
    }
    // validamos si el ciudadano esta fallecido o no
    const UsuarioEstaFallecido = async ()=>{
        // si no se ha seleccionado un homónimo, entonces consultamos si está fallecido
        if(props.datosCiudadanoTable.estadoHomonimoSeleccionado !== 0 ){
            // mostramos modal
            setLoadingMessage({loading: true, title:'Validando si esta fallecido ...'})
            // Si el argumento props.estado.... no tiene un valor, entonces consultamos
            if(!props.estadoPadronDelCiudadanoEstaFallecido){
                try {
                    // LLamamos método
                    let response = await ApiServices.ConsultarDatosDeFallecidos.consultaFallecidos(props.datosCiudadanoTable.idSolicitud)
                    // Si retorna un error, seteamos parámetros vacíos o default
                    if(response.error!==null){
                        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO(' ')
                        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO(false)
                        setEstaFallecido({state: 'No', fechaDefuncion:''})
                    }else{
                    // de lo contrario, asignamos parámetros
                        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO(response.data[0].fechaDefuncion)
                        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO(true)
                        setEstaFallecido({state: 'Si', fechaDefuncion:functions.splitDate(response.data[0].fechaDefuncion)})
                    }
                } catch (error) {
                    showMessagePersonalizedPosition('error', '¡Advertencia!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            //
            }else{
                // 
                if(props.estadoPadronDelCiudadanoEstaFallecido === ' '){
                    setEstaFallecido({state: 'No', fechaDefuncion:''})
                }else{
                    setEstaFallecido({state: 'Si', fechaDefuncion:functions.splitDate(props.estadoPadronDelCiudadanoEstaFallecido)})
                }
            }
        }else{
            if(props.datosCiudadanoTable.estadoHomonimoSeleccionado === 0){
                setLoadingMessage({loading: true, title:'El Homónimo seleccionado SI está fallecido'})
                props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO(' ')
                props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO(true)
                setEstaFallecido({state: 'Si', fechaDefuncion:''})
            }else{
                setLoadingMessage({loading: true, title:'El Homónimo seleccionado NO está fallecido'})
                props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO(' ')
                props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO(false)
                setEstaFallecido({state: 'No', fechaDefuncion:''})
            }
        }
        setTimeout(()=>{
            setLoadingMessage({loading: false, title:''})
        }, 3000)
    }



    const estadoEventoRENAP = () => {
        if(props.datosCiudadanoTable.datosSolicitudEmpadronamiento?.catalogoEventosRenap?.isallowedForRegister === 1){
            props.SOLICITUD_EMPADRONAMIENTO_SET_EVENTO_RENAP(true)
        }else{
            props.SOLICITUD_EMPADRONAMIENTO_SET_EVENTO_RENAP(false)
        }
    }
    useEffect(() => {
        if(props.open || props.rechazarSolicitudPortalWeb){
            (async () => {
                // estadoEventoRENAP();
                await getUserState();
                await UsuarioEstaFallecido();
            })();          
        }
    },[props.open || props.rechazarSolicitudPortalWeb])

    return (
    <>
    {/* DIALOGO */}
        <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
    {/* INFORMACION DEL ESTADO DEL PADRON (CIUDADANO U HOMÓNIMO) */}
        <Grid container className={classes.marginBotton}>
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>ESTADO EN EL PADRON</strong> <Divider /></div>
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="¿Está Empadronado? " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                { userState.state === "Si" ? 
                    <Chip variant="outlined"  className={classes.colorChipError} label={userState.state} />
                    : <Chip variant="outlined" className={classes.colorChipSuccess} label={userState.state} />
                }
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Código de Referencia: " />
                    <ListItemIcon className={classes.colorIcon}><AssignmentInd/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={userState.ballotNumber} />
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="¿Está Fallecido? " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                { estaFallecido.state === "Si" ? 
                    <Chip variant="outlined"  className={classes.colorChipError} label={estaFallecido.state} />
                    : <Chip variant="outlined" className={classes.colorChipSuccess} label={estaFallecido.state} />
                }
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha Defunción: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={estaFallecido.fechaDefuncion} />
            </Grid>
            {/* <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="¿Se puede Empadronar (Evento RENAP)? " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                { props.datosCiudadanoTable.datosSolicitudEmpadronamiento?.catalogoEventosRenap?.isallowedForRegister === 1 ?
                    <Chip  className={classes.colorChipSuccess} label={'Sí'} />
                    : <Chip className={classes.colorChipError} label={'No'} />
                }
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Evento RENAP: " />
                    <ListItemIcon className={classes.colorIcon}><AssignmentInd/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.catalogoEventosRenap?.name} />
            </Grid> */}
        </Grid>
    </>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(EstatusUsuario);